export const translations = {
  en: {
    navHome: "Home",
    navDonation: "Donation",
    navExpense: "Expense",
    navEvents: "Events",
    navGallery: "Gallery",
    navCommunity: "Community",
    login: "Login",
    logout: "Logout",
    year: "Year",

    heroTitlePrefix: "Bharat Mata Navdurga",
    heroTitleSuffix: "Utsav Samiti",
    heroSubtitle:
      "Godhar, Rewa (M.P.) — Celebrating devotion, unity & seva together",
    watchLive: "Watch Live",
    happeningToday: "Happening Today",
    nextCelebration: "Next Celebration",
    day: "Day",
    days: "Days",

    daanpeti: "Daanpeti",
    expense: "Expense",
    gallery: "Gallery",
    community: "Community",
    events: "Events",

    liveDarshan: "Live Darshan",
    announcements: "Announcements",
    upcomingEvents: "Upcoming Events",

    totalDonations: "Total Donations",
    totalExpenses: "Total Expenses",
    amountLeft: "Amount Left",
    fundUtilization: "Utilized",
    top50Donors: "Top 50 Donors",
    donorsTitle: "Our Generous Donors",
    utilised: "Utilised",
    fundsUsed: "of donations spent",
    showAllDonors: "Show all",
    showLess: "Show less",
    noDonorMatch: "No matching donor found",

    loading: "Loading…",
    somethingWentWrong: "Something Went Wrong",
    retry: "Retry",
    tapToReadMore: "Tap to read more",
    close: "Close",

    eventsUpcoming: "Upcoming Events",
    eventsPast: "Past Events",
    eventsEmpty: "No events published yet. Please check back soon.",
    backEvents: "Events",

    galleryTitle: "Gallery",
    galleryEmpty: "No Images Found...",

    communityTitle: "Our Community",
    communityLeaders: "Committee Leaders",
    communityMembers: "Our Members",
    communityDevelopedBy: "Developed By",
    communityEmptyTitle: "No members added yet",
    communityEmptyBody:
      "Committee members will appear here once they're added.",

    loginTitle: "Finance Admin Login",
    loginSubtitle: "Access to manage donation & expense entries",
    loginEmail: "Email",
    loginPassword: "Password",
    loginSubmit: "Login",

    footerDevelopedBy: "Developed By Prateek",

    allDonations: "Donations",
    allExpenses: "Expenses",
    updateActivity: "Update Activity",
    addNew: "Add New",
    totalCollected: "Total Collected",
    totalSpent: "Total Spent",
    totalEntries: "Total Entries",
    pendingLabel: "Pending",
    filterPendings: "Filter Pending's",
    export: "Export",
    sharePdf: "Share PDF",
    searchPlaceholder: "Search...",
    addressLabel: "Address",
    dateLabel: "Date",
    spentByLabel: "Spent By",
    descriptionLabel: "Description",
    collected: "Collected",
    paymentDone: "Payment Done",
    paymentPending: "Payment Pending",
    statusPending: "Pending",
    listEmpty: "List is empty!",

    addDonationTitle: "Add Donation",
    editDonationTitle: "Edit Donation",
    addExpenseTitle: "Add Expense",
    editExpenseTitle: "Edit Expense",
    nameLabel: "Name",
    donorNamePlaceholder: "Enter donor's name",
    amountLabel: "Amount",
    amountPlaceholder: "Enter amount",
    addressSelectLabel: "Address",
    expenseDescPlaceholder: "Enter expense description",
    recordDonationSubtitle: "Record a devotee's contribution",
    logExpenseSubtitle: "Log a committee expense entry",
    uploadReceiptImages: "Upload Receipt Images",
    chooseFiles: "Choose Files",
    uploadingText: "Uploading...",
    saving: "Saving…",
    selectOption: "Select",
    completed: "Completed",
    paymentCompleted: "Payment Completed",
    updateDonation: "Update Donation",
    updateExpense: "Update Expense",
    addDonation: "Add Donation",
    addExpense: "Add Expense",
  },
  hi: {
    navHome: "होम",
    navDonation: "दान",
    navExpense: "व्यय",
    navEvents: "कार्यक्रम",
    navGallery: "गैलरी",
    navCommunity: "समुदाय",
    login: "लॉगिन",
    logout: "लॉगआउट",
    year: "वर्ष",

    heroTitlePrefix: "भारत माता नवदुर्गा",
    heroTitleSuffix: "उत्सव समिति",
    heroSubtitle: "गोड़हर, रीवा (म.प्र.) — भक्ति, एकता और सेवा का उत्सव",
    watchLive: "लाइव देखें",
    happeningToday: "आज है",
    nextCelebration: "अगला उत्सव",
    day: "दिन",
    days: "दिन",

    daanpeti: "दान पेटी",
    expense: "व्यय",
    gallery: "गैलरी",
    community: "समुदाय",
    events: "कार्यक्रम",

    liveDarshan: "लाइव दर्शन",
    announcements: "सूचनाएं",
    upcomingEvents: "आगामी कार्यक्रम",

    totalDonations: "कुल दान",
    totalExpenses: "कुल व्यय",
    amountLeft: "शेष राशि",
    fundUtilization: "उपयोग किया गया",
    top50Donors: "शीर्ष 50 दानदाता",
    donorsTitle: "हमारे उदार दानदाता",
    utilised: "उपयोग",
    fundsUsed: "दान राशि खर्च हुई",
    showAllDonors: "सभी देखें",
    showLess: "कम दिखाएं",
    noDonorMatch: "कोई दानदाता नहीं मिला",

    loading: "लोड हो रहा है…",
    somethingWentWrong: "कुछ गलत हो गया",
    retry: "पुनः प्रयास करें",
    tapToReadMore: "पूरा पढ़ने के लिए टैप करें",
    close: "बंद करें",

    eventsUpcoming: "आगामी कार्यक्रम",
    eventsPast: "पिछले कार्यक्रम",
    eventsEmpty: "अभी तक कोई कार्यक्रम प्रकाशित नहीं हुआ। कृपया बाद में देखें।",
    backEvents: "कार्यक्रम",

    galleryTitle: "गैलरी",
    galleryEmpty: "कोई छवि नहीं मिली...",

    communityTitle: "हमारा समुदाय",
    communityLeaders: "समिति के पदाधिकारी",
    communityMembers: "हमारे सदस्य",
    communityDevelopedBy: "निर्माता",
    communityEmptyTitle: "अभी तक कोई सदस्य नहीं जोड़ा गया",
    communityEmptyBody: "सदस्यों के जुड़ने के बाद वे यहाँ दिखाई देंगे।",

    loginTitle: "फाइनेंस एडमिन लॉगिन",
    loginSubtitle: "दान व व्यय प्रविष्टियों के प्रबंधन हेतु पहुँच",
    loginEmail: "ईमेल",
    loginPassword: "पासवर्ड",
    loginSubmit: "लॉगिन",

    footerDevelopedBy: "प्रतीक द्वारा निर्मित",

    allDonations: "दान",
    allExpenses: "व्यय",
    updateActivity: "अपडेट गतिविधि",
    addNew: "नया जोड़ें",
    totalCollected: "कुल एकत्रित",
    totalSpent: "कुल खर्च",
    totalEntries: "कुल प्रविष्टियाँ",
    pendingLabel: "लंबित",
    filterPendings: "लंबित फ़िल्टर करें",
    export: "एक्सपोर्ट",
    sharePdf: "PDF शेयर करें",
    searchPlaceholder: "खोजें...",
    addressLabel: "पता",
    dateLabel: "तारीख",
    spentByLabel: "किसके द्वारा खर्च",
    descriptionLabel: "विवरण",
    collected: "प्राप्त",
    paymentDone: "भुगतान हो गया",
    paymentPending: "भुगतान लंबित",
    statusPending: "लंबित",
    listEmpty: "सूची खाली है!",

    addDonationTitle: "दान जोड़ें",
    editDonationTitle: "दान संपादित करें",
    addExpenseTitle: "व्यय जोड़ें",
    editExpenseTitle: "व्यय संपादित करें",
    nameLabel: "नाम",
    donorNamePlaceholder: "दानदाता का नाम दर्ज करें",
    amountLabel: "राशि",
    amountPlaceholder: "राशि दर्ज करें",
    addressSelectLabel: "पता",
    expenseDescPlaceholder: "व्यय का विवरण दर्ज करें",
    recordDonationSubtitle: "श्रद्धालु का योगदान दर्ज करें",
    logExpenseSubtitle: "समिति व्यय प्रविष्टि दर्ज करें",
    uploadReceiptImages: "रसीद छवियाँ अपलोड करें",
    chooseFiles: "फ़ाइलें चुनें",
    uploadingText: "अपलोड हो रहा है...",
    saving: "सहेजा जा रहा है…",
    selectOption: "चुनें",
    completed: "पूर्ण",
    paymentCompleted: "भुगतान पूर्ण",
    updateDonation: "दान अपडेट करें",
    updateExpense: "व्यय अपडेट करें",
    addDonation: "दान जोड़ें",
    addExpense: "व्यय जोड़ें",
  },
};
